import { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success("Signed in");
      const dest = loc.state?.from || (u.is_admin ? "/admin" : "/");
      navigate(dest);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bg-white min-h-screen" data-testid="login-page">
      <div className="max-w-md mx-auto px-6 pt-10 pb-16">
        <div className="text-center mb-8">
          <Link to="/" className="font-display text-3xl font-semibold">shopnest<span className="text-[#c8532e]">.</span></Link>
        </div>
        <div className="card p-6">
          <h1 className="font-display text-2xl font-semibold mb-4">Sign in</h1>
          <form onSubmit={submit} className="space-y-4">
            <label className="block">
              <span className="text-xs font-semibold uppercase tracking-[0.16em] text-[#6b6b6b]">Email</span>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 w-full h-10 bg-white border border-[#e0d8c8] focus:border-[#c8532e] focus:ring-2 focus:ring-[#c8532e]/30 rounded-md outline-none px-3 text-sm"
                data-testid="login-email-input"
              />
            </label>
            <label className="block">
              <span className="text-xs font-semibold uppercase tracking-[0.16em] text-[#6b6b6b]">Password</span>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 w-full h-10 bg-white border border-[#e0d8c8] focus:border-[#c8532e] focus:ring-2 focus:ring-[#c8532e]/30 rounded-md outline-none px-3 text-sm"
                data-testid="login-password-input"
              />
            </label>
            <button type="submit" disabled={busy} className="btn-primary w-full text-sm" data-testid="login-submit">
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </form>
          <div className="mt-4 text-xs text-[#6b6b6b]">
            By continuing, you agree to shopnest's Terms and Privacy.
          </div>
        </div>

        <div className="relative my-6 text-center text-xs text-[#6b6b6b]">
          <span className="bg-[#f5f0e8] px-2 relative z-10">New to shopnest?</span>
          <div className="absolute inset-x-0 top-1/2 h-px bg-[#e0d8c8]" />
        </div>
        <Link
          to="/signup"
          className="btn-outline block w-full text-center text-sm"
          data-testid="login-to-signup"
        >
          Create your shopnest account
        </Link>
      </div>
    </div>
  );
}
